/*
 * TASK POPUP STYLES
 *
 * Keeps shared task-dialog chrome compact and consistent across task entry points.
 *
 * Recent changes:
 * - Aliases the feature-neutral popup chrome so task and note dialogs cannot drift.
 */

import {
  POPUP_CLOSE_CLASS_NAME,
  POPUP_HEADER_CLASS_NAME,
  POPUP_TITLE_CLASS_NAME,
} from '../../popup/popupStyles';

export const TASK_POPUP_HEADER_CLASS_NAME = POPUP_HEADER_CLASS_NAME;
export const TASK_POPUP_TITLE_CLASS_NAME = POPUP_TITLE_CLASS_NAME;
export const TASK_POPUP_CLOSE_CLASS_NAME = POPUP_CLOSE_CLASS_NAME;
